module.exports = __webpack_public_path__ + "img/material-card2.d8e5945a.png";